import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvedmanpowerrequest',
  templateUrl: './approvedmanpowerrequest.component.html',
  styleUrls: ['./approvedmanpowerrequest.component.css']
})
export class ApprovedmanpowerrequestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
